module.exports = __webpack_public_path__ + "img/facebook.a937dc2a.svg";